var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{ 'is-closed': _vm.isClosed }],on:{"click":function($event){return _vm.$emit(_vm.sidebarToggleEvent)}}},[_c('v-icon',[_vm._v("mdi-menu-open")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }